export default __webpack_public_path__ + "static/media/Nunito-Bold.f75a5064.eot";